// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__O\\+MIY.styles_ocean-50__LmsZO {
  color: #e6f2ff;
}

.styles_color__O\\+MIY.styles_ocean-100__GD6w6 {
  color: #e6f2ff;
}

.styles_color__O\\+MIY.styles_ocean-200__EKxLB {
  color: #b3daff;
}

.styles_color__O\\+MIY.styles_ocean-300__FBN5n {
  color: #7abfff;
}

.styles_color__O\\+MIY.styles_ocean-400__NApyN {
  color: #2392fb;
}

.styles_color__O\\+MIY.styles_ocean-500__J9-35 {
  color: #0074e0;
}

.styles_color__O\\+MIY.styles_ocean-600__dUOif {
  color: #043571;
}

.styles_color__O\\+MIY.styles_space-50__rp5V\\+ {
  color: #f0f0f0;
}

.styles_color__O\\+MIY.styles_space-100__3wyT2 {
  color: #e3e3e3;
}

.styles_color__O\\+MIY.styles_space-200__7\\+APP {
  color: #bfbfbf;
}

.styles_color__O\\+MIY.styles_space-300__Y304i {
  color: gray;
}

.styles_color__O\\+MIY.styles_space-400__cOSnH {
  color: #616161;
}

.styles_color__O\\+MIY.styles_space-500__4qwK1 {
  color: #283439;
}

.styles_color__O\\+MIY.styles_gray-50__ttu\\+N {
  color: #eff3f6;
}

.styles_color__O\\+MIY.styles_gray-100__4eTyx {
  color: #e6ecef;
}

.styles_color__O\\+MIY.styles_gray-200__lwQPW {
  color: #cfd8de;
}

.styles_color__O\\+MIY.styles_gray-300__GkG\\+T {
  color: #a8b9c2;
}

.styles_color__O\\+MIY.styles_gray-400__ZAlnN {
  color: #7e98a5;
}

.styles_color__O\\+MIY.styles_gray-500__STjTT {
  color: #738f9c;
}

.styles_color__O\\+MIY.styles_green-50__EEINr {
  color: #e3fdf6;
}

.styles_color__O\\+MIY.styles_green-100__18\\+90 {
  color: #c5f6ea;
}

.styles_color__O\\+MIY.styles_green-200__iFeXM {
  color: #69ddc2;
}

.styles_color__O\\+MIY.styles_green-300__-wYbW {
  color: #45bfa3;
}

.styles_color__O\\+MIY.styles_green-400__G1aj8 {
  color: #1cab8a;
}

.styles_color__O\\+MIY.styles_green-500__5A0gl {
  color: #128268;
}

.styles_color__O\\+MIY.styles_red-50__2abRC {
  color: #fff0f3;
}

.styles_color__O\\+MIY.styles_red-100__rKeZ6 {
  color: #f9d2db;
}

.styles_color__O\\+MIY.styles_red-200__MQ9i8 {
  color: #f8b4c4;
}

.styles_color__O\\+MIY.styles_red-300__4ePCq {
  color: #e85e81;
}

.styles_color__O\\+MIY.styles_red-400__hI\\+yO {
  color: #e23661;
}

.styles_color__O\\+MIY.styles_red-500__A0yUe {
  color: #b82348;
}

.styles_color__O\\+MIY.styles_yellow-50__gzrmK {
  color: #fffae6;
}

.styles_color__O\\+MIY.styles_yellow-100__SMRhH {
  color: #fff0b3;
}

.styles_color__O\\+MIY.styles_yellow-200__MmipN {
  color: #ffe380;
}

.styles_color__O\\+MIY.styles_yellow-300__ilxM\\+ {
  color: #ffcf57;
}

.styles_color__O\\+MIY.styles_yellow-400__lrwou {
  color: #ffc60a;
}

.styles_color__O\\+MIY.styles_yellow-500__5rqXt {
  color: #ffb700;
}

.styles_color__O\\+MIY.styles_orange-50__ktf3r {
  color: #fff2eb;
}

.styles_color__O\\+MIY.styles_orange-100__wl11w {
  color: #ffe4d6;
}

.styles_color__O\\+MIY.styles_orange-200__YSQRp {
  color: #ffc69e;
}

.styles_color__O\\+MIY.styles_orange-300__nJOKm {
  color: #ffa047;
}

.styles_color__O\\+MIY.styles_orange-400__UV04h {
  color: #ff7b42;
}

.styles_color__O\\+MIY.styles_orange-500__CYtzS {
  color: #ee4920;
}

.styles_color__O\\+MIY.styles_turquoise-50__LoHj3 {
  color: transparent;
}

.styles_color__O\\+MIY.styles_turquoise-100__O6CoD {
  color: #e6fcff;
}

.styles_color__O\\+MIY.styles_turquoise-200__pw3f0 {
  color: #b3f5ff;
}

.styles_color__O\\+MIY.styles_turquoise-300__FNGmV {
  color: #78e2f2;
}

.styles_color__O\\+MIY.styles_turquoise-400__m8FNQ {
  color: #00c7e6;
}

.styles_color__O\\+MIY.styles_turquoise-500__zgKcL {
  color: transparent;
}

.styles_color__O\\+MIY.styles_turquoise-600__fDktm {
  color: transparent;
}

.styles_color__O\\+MIY.styles_violet-50__5x2Ef {
  color: #eae6ff;
}

.styles_color__O\\+MIY.styles_violet-100__TugCe {
  color: #d9d1ff;
}

.styles_color__O\\+MIY.styles_violet-200__O6wVi {
  color: #bfb3ff;
}

.styles_color__O\\+MIY.styles_violet-300__A80v2 {
  color: #9d90ea;
}

.styles_color__O\\+MIY.styles_violet-400__QO94e {
  color: #8678d9;
}

.styles_color__O\\+MIY.styles_violet-500__EXSag {
  color: #6f5ccc;
}

.styles_color__O\\+MIY.styles_snow-50__l2ukB {
  color: white;
}

.styles_color__O\\+MIY.styles_snow-100__voKiz {
  color: #f7f7f7;
}

.styles_color__O\\+MIY.styles_snow-200__fbstb {
  color: #f0efef;
}

.styles_color__O\\+MIY.styles_snow-300__PbWYi {
  color: #e6e6e6;
}

.styles_color__O\\+MIY.styles_snow-400__Fo2Dx {
  color: #e1e0e0;
}

.styles_color__O\\+MIY.styles_snow-500__Z1q16 {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__VKeQU.styles_ocean__gvTiZ {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__VKeQU.styles_ocean-light__D2tWW {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__VKeQU.styles_green__KhGxb {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__VKeQU.styles_green-light__riBJm {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__VKeQU.styles_red__7Y58A {
  background-color: #e23661;
  color: white;
}

.styles_background-color__VKeQU.styles_red-light__P-3lN {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__VKeQU.styles_orange__5Fp1c {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__VKeQU.styles_orange-light__RzwdQ {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__VKeQU.styles_space__ioGlY {
  background-color: #616161;
  color: white;
}

.styles_background-color__VKeQU.styles_space-light__dqG\\+0 {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__VKeQU.styles_gray-light__wG8is {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__VKeQU.styles_violet__l8vzG {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__VKeQU.styles_violet-light__6awvW {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__VKeQU.styles_yellow__-UN8p {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__VKeQU.styles_yellow-light__Bfvkm {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_root__wuWWb {
  -webkit-appearance: none;
          appearance: none;
  background-color: transparent;
  border: 0;
  border-radius: 0;
  color: inherit;
  cursor: pointer;
  margin: 0;
  outline: 0;
  padding: 0;
  position: relative;
  -webkit-tap-highlight-color: transparent;
  text-align: left;
  text-decoration: none;
  -webkit-user-select: none;
          user-select: none;
  vertical-align: middle;
  font-weight: 400;
  font-size: 1rem;
  letter-spacing: -0.09px;
  line-height: 20px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
  background-color: #f7f7f7;
  border-radius: 5px;
  gap: 4px ;
  height: 40px;
  min-width: 73px;
  padding: 0px 12px ;
}
.styles_root__wuWWb::-moz-focus-inner {
  border-style: none;
}
.styles_root__wuWWb,
.styles_root__wuWWb svg {
  color: #616161;
}
.styles_root__wuWWb .styles_loadingDots__cEVZc,
.styles_root__wuWWb svg .styles_loadingDots__cEVZc {
  background-color: #616161;
}
.styles_root__wuWWb:disabled {
  cursor: default;
}
.styles_root__wuWWb:disabled * {
  cursor: default;
}
.styles_root__wuWWb.styles_small__un6\\+5 {
  height: 32px;
}
.styles_root__wuWWb.styles_fullWidth__PzUwe {
  width: 100% !important;
}
.styles_root__wuWWb.styles_primary__LoXCN {
  background-color: #0074e0;
}
.styles_root__wuWWb.styles_primary__LoXCN,
.styles_root__wuWWb.styles_primary__LoXCN svg {
  color: white;
}
.styles_root__wuWWb.styles_primary__LoXCN .styles_loadingDots__cEVZc {
  background-color: white;
}
.styles_root__wuWWb.styles_secondary__dvfx8 {
  background-color: #b3daff;
}
.styles_root__wuWWb.styles_secondary__dvfx8,
.styles_root__wuWWb.styles_secondary__dvfx8 svg {
  color: #0074e0;
}
.styles_root__wuWWb.styles_secondary__dvfx8 .styles_loadingDots__cEVZc {
  background-color: #0074e0;
}
.styles_root__wuWWb.styles_ghost__fHgtd {
  background-color: transparent;
}
.styles_root__wuWWb.styles_ghost__fHgtd,
.styles_root__wuWWb.styles_ghost__fHgtd svg {
  color: #0074e0;
}
.styles_root__wuWWb.styles_ghost__fHgtd .styles_loadingDots__cEVZc {
  background-color: #0074e0;
}
.styles_root__wuWWb.styles_outlined__can7d {
  background-color: #eff3f6;
  border: 2px solid #a8b9c2;
}
.styles_root__wuWWb.styles_outlined__can7d,
.styles_root__wuWWb.styles_outlined__can7d svg {
  color: #7e98a5;
}
.styles_root__wuWWb.styles_outlined__can7d .styles_loadingDots__cEVZc {
  background-color: #7e98a5;
}
.styles_root__wuWWb.styles_error__bFEK\\+ {
  background-color: #b82348;
}
.styles_root__wuWWb.styles_error__bFEK\\+,
.styles_root__wuWWb.styles_error__bFEK\\+ svg {
  color: white;
}
.styles_root__wuWWb.styles_error__bFEK\\+ .styles_loadingDots__cEVZc {
  background-color: white;
}
.styles_root__wuWWb.styles_warning__fIt24 {
  background-color: #ffc60a;
}
.styles_root__wuWWb.styles_warning__fIt24,
.styles_root__wuWWb.styles_warning__fIt24 svg {
  color: #283439;
}
.styles_root__wuWWb.styles_warning__fIt24 .styles_loadingDots__cEVZc {
  background-color: #283439;
}
.styles_root__wuWWb.styles_errorLight__V1VTM {
  background-color: #f9d2db;
}
.styles_root__wuWWb.styles_errorLight__V1VTM,
.styles_root__wuWWb.styles_errorLight__V1VTM svg {
  color: #b82348;
}
.styles_root__wuWWb.styles_errorLight__V1VTM .styles_loadingDots__cEVZc {
  background-color: #b82348;
}
.styles_root__wuWWb.styles_warningLight__6qI\\+e {
  background-color: #fffae6;
}
.styles_root__wuWWb.styles_warningLight__6qI\\+e,
.styles_root__wuWWb.styles_warningLight__6qI\\+e svg {
  color: #283439;
}
.styles_root__wuWWb.styles_warningLight__6qI\\+e .styles_loadingDots__cEVZc {
  background-color: #283439;
}
.styles_root__wuWWb.styles_disabled__9PiL9 svg {
  color: #bfbfbf;
}
.styles_root__wuWWb:hover, .styles_root__wuWWb.styles_loading__2jfYr {
  background-color: #f0efef;
}
.styles_root__wuWWb:hover.styles_primary__LoXCN, .styles_root__wuWWb.styles_loading__2jfYr.styles_primary__LoXCN {
  background-color: #2392fb;
}
.styles_root__wuWWb:hover.styles_secondary__dvfx8, .styles_root__wuWWb.styles_loading__2jfYr.styles_secondary__dvfx8 {
  background-color: #e6f2ff;
}
.styles_root__wuWWb:hover.styles_secondary__dvfx8,
.styles_root__wuWWb:hover.styles_secondary__dvfx8 svg, .styles_root__wuWWb.styles_loading__2jfYr.styles_secondary__dvfx8,
.styles_root__wuWWb.styles_loading__2jfYr.styles_secondary__dvfx8 svg {
  color: #2392fb;
}
.styles_root__wuWWb:hover.styles_secondary__dvfx8 .styles_loadingDots__cEVZc, .styles_root__wuWWb.styles_loading__2jfYr.styles_secondary__dvfx8 .styles_loadingDots__cEVZc {
  background-color: #2392fb;
}
.styles_root__wuWWb:hover.styles_ghost__fHgtd, .styles_root__wuWWb.styles_loading__2jfYr.styles_ghost__fHgtd {
  background-color: #f0efef;
}
.styles_root__wuWWb:hover.styles_outlined__can7d, .styles_root__wuWWb.styles_loading__2jfYr.styles_outlined__can7d {
  background-color: #e6ecef;
  border: 2px solid #a8b9c2;
}
.styles_root__wuWWb:hover.styles_outlined__can7d,
.styles_root__wuWWb:hover.styles_outlined__can7d svg, .styles_root__wuWWb.styles_loading__2jfYr.styles_outlined__can7d,
.styles_root__wuWWb.styles_loading__2jfYr.styles_outlined__can7d svg {
  color: #7e98a5;
}
.styles_root__wuWWb:hover.styles_outlined__can7d .styles_loadingDots__cEVZc, .styles_root__wuWWb.styles_loading__2jfYr.styles_outlined__can7d .styles_loadingDots__cEVZc {
  background-color: #7e98a5;
}
.styles_root__wuWWb:hover.styles_error__bFEK\\+, .styles_root__wuWWb.styles_loading__2jfYr.styles_error__bFEK\\+ {
  background-color: #e85e81;
}
.styles_root__wuWWb:hover.styles_warning__fIt24, .styles_root__wuWWb.styles_loading__2jfYr.styles_warning__fIt24 {
  background-color: #ffe380;
}
.styles_root__wuWWb:hover.styles_errorLight__V1VTM, .styles_root__wuWWb.styles_loading__2jfYr.styles_errorLight__V1VTM {
  background-color: #f8b4c4;
}
.styles_root__wuWWb:hover.styles_warningLight__6qI\\+e, .styles_root__wuWWb.styles_loading__2jfYr.styles_warningLight__6qI\\+e {
  background-color: #fff0b3;
}
.styles_root__wuWWb:active {
  background-color: #e6ecef;
}
.styles_root__wuWWb:active.styles_primary__LoXCN {
  background-color: #0074e0;
}
.styles_root__wuWWb:active.styles_secondary__dvfx8 {
  background-color: #b3daff;
}
.styles_root__wuWWb:active.styles_secondary__dvfx8,
.styles_root__wuWWb:active.styles_secondary__dvfx8 svg {
  color: #0074e0;
}
.styles_root__wuWWb:active.styles_secondary__dvfx8 .styles_loadingDots__cEVZc {
  background-color: #0074e0;
}
.styles_root__wuWWb:active.styles_ghost__fHgtd {
  background-color: #f0efef;
}
.styles_root__wuWWb:active.styles_error__bFEK\\+ {
  background-color: #b82348;
}
.styles_root__wuWWb:active.styles_warning__fIt24 {
  background-color: #ffc60a;
}
.styles_root__wuWWb:active.styles_errorLight__V1VTM {
  background-color: #f9d2db;
}
.styles_root__wuWWb:active.styles_warningLight__6qI\\+e {
  background-color: #fffae6;
}
.styles_root__wuWWb.styles_disabled__9PiL9 {
  background-color: #f7f7f7;
  color: #bfbfbf;
  cursor: unset;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_primary__LoXCN {
  background-color: #eff3f6;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_primary__LoXCN,
.styles_root__wuWWb.styles_disabled__9PiL9.styles_primary__LoXCN svg {
  color: #a8b9c2;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_primary__LoXCN .styles_loadingDots__cEVZc {
  background-color: #a8b9c2;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_secondary__dvfx8 {
  background-color: #e6f2ff;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_secondary__dvfx8,
.styles_root__wuWWb.styles_disabled__9PiL9.styles_secondary__dvfx8 svg {
  color: #7abfff;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_secondary__dvfx8 .styles_loadingDots__cEVZc {
  background-color: #7abfff;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_ghost__fHgtd {
  background-color: transparent;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_ghost__fHgtd,
.styles_root__wuWWb.styles_disabled__9PiL9.styles_ghost__fHgtd svg {
  color: #7abfff;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_ghost__fHgtd .styles_loadingDots__cEVZc {
  background-color: #7abfff;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_error__bFEK\\+ {
  background-color: #f9d2db;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_error__bFEK\\+,
.styles_root__wuWWb.styles_disabled__9PiL9.styles_error__bFEK\\+ svg {
  color: white;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_error__bFEK\\+ .styles_loadingDots__cEVZc {
  background-color: white;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_warning__fIt24 {
  background-color: #fff0b3;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_warning__fIt24,
.styles_root__wuWWb.styles_disabled__9PiL9.styles_warning__fIt24 svg {
  color: #bfbfbf;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_warning__fIt24 .styles_loadingDots__cEVZc {
  background-color: #bfbfbf;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_errorLight__V1VTM {
  background-color: #f9d2db;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_errorLight__V1VTM,
.styles_root__wuWWb.styles_disabled__9PiL9.styles_errorLight__V1VTM svg {
  color: #f8b4c4;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_errorLight__V1VTM .styles_loadingDots__cEVZc {
  background-color: #f8b4c4;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_warningLight__6qI\\+e {
  background-color: #fffae6;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_warningLight__6qI\\+e,
.styles_root__wuWWb.styles_disabled__9PiL9.styles_warningLight__6qI\\+e svg {
  color: #bfbfbf;
}
.styles_root__wuWWb.styles_disabled__9PiL9.styles_warningLight__6qI\\+e .styles_loadingDots__cEVZc {
  background-color: #bfbfbf;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/ui-kit/components/button/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/_theme/_misc.scss","webpack://./src/ui-kit/styles/_theme/_typography.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADdA;EEuBI,wBAAA;UAAA,gBAAA;EACA,6BAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,sBAAA;ECaA,gBAAA;EANA,eAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;EHCrB,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AA2VJ;AE7TI;EACI,kBAAA;AF+TR;AA5VI;;EAII,cAFQ;AA8VhB;AA1VQ;;EACI,yBALI;AAkWhB;AAzVI;EACI,eAAA;AA2VR;AAzVQ;EACI,eAAA;AA2VZ;AAvVI;EACI,YAAA;AAyVR;AAtVI;EACI,sBAAA;AAwVR;AArVI;EAGI,yBAAA;AAqVR;AAnVQ;;EAEI,YANI;AA2VhB;AAlVQ;EACI,uBAVI;AA8VhB;AAhVI;EAGI,yBAAA;AAgVR;AA9UQ;;EAEI,cANI;AAsVhB;AA7UQ;EACI,yBAVI;AAyVhB;AA3UI;EAGI,6BAAA;AA2UR;AAzUQ;;EAEI,cANI;AAiVhB;AAxUQ;EACI,yBAVI;AAoVhB;AAtUI;EAGI,yBAAA;EACA,yBAAA;AAsUR;AApUQ;;EAEI,cAPI;AA6UhB;AAnUQ;EACI,yBAXI;AAgVhB;AAjUI;EAGI,yBAAA;AAiUR;AA/TQ;;EAEI,YANI;AAuUhB;AA9TQ;EACI,uBAVI;AA0UhB;AA5TI;EAGI,yBAAA;AA4TR;AA1TQ;;EAEI,cANI;AAkUhB;AAzTQ;EACI,yBAVI;AAqUhB;AAvTI;EAGI,yBAAA;AAuTR;AArTQ;;EAEI,cANI;AA6ThB;AApTQ;EACI,yBAVI;AAgUhB;AAlTI;EAGI,yBAAA;AAkTR;AAhTQ;;EAEI,cANI;AAwThB;AA/SQ;EACI,yBAVI;AA2ThB;AA7SI;EACI,cAAA;AA+SR;AA5SI;EAEI,yBAAA;AA6SR;AA3SQ;EACI,yBAAA;AA6SZ;AA1SQ;EAGI,yBAAA;AA0SZ;AAxSY;;;EAEI,cANI;AAiTpB;AAxSY;EACI,yBAVI;AAoTpB;AAtSQ;EACI,yBAAA;AAwSZ;AArSQ;EAGI,yBAAA;EACA,yBAAA;AAqSZ;AAnSY;;;EAEI,cAPI;AA6SpB;AAnSY;EACI,yBAXI;AAgTpB;AAjSQ;EACI,yBAAA;AAmSZ;AAhSQ;EACI,yBAAA;AAkSZ;AA/RQ;EACI,yBAAA;AAiSZ;AA9RQ;EACI,yBAAA;AAgSZ;AA5RI;EACI,yBAAA;AA8RR;AA5RQ;EACI,yBAAA;AA8RZ;AA3RQ;EAGI,yBAAA;AA2RZ;AAzRY;;EAEI,cANI;AAiSpB;AAxRY;EACI,yBAVI;AAoSpB;AAtRQ;EACI,yBAAA;AAwRZ;AArRQ;EACI,yBAAA;AAuRZ;AApRQ;EACI,yBAAA;AAsRZ;AAnRQ;EACI,yBAAA;AAqRZ;AAlRQ;EACI,yBAAA;AAoRZ;AAhRI;EACI,yBAAA;EACA,cAAA;EACA,aAAA;AAkRR;AAhRQ;EAGI,yBAAA;AAgRZ;AA9QY;;EAEI,cANI;AAsRpB;AA7QY;EACI,yBAVI;AAyRpB;AA3QQ;EAGI,yBAAA;AA2QZ;AAzQY;;EAEI,cANI;AAiRpB;AAxQY;EACI,yBAVI;AAoRpB;AAtQQ;EAGI,6BAAA;AAsQZ;AApQY;;EAEI,cANI;AA4QpB;AAnQY;EACI,yBAVI;AA+QpB;AAjQQ;EAGI,yBAAA;AAiQZ;AA/PY;;EAEI,YANI;AAuQpB;AA9PY;EACI,uBAVI;AA0QpB;AA5PQ;EAGI,yBAAA;AA4PZ;AA1PY;;EAEI,cANI;AAkQpB;AAzPY;EACI,yBAVI;AAqQpB;AAvPQ;EAGI,yBAAA;AAuPZ;AArPY;;EAEI,cANI;AA6PpB;AApPY;EACI,yBAVI;AAgQpB;AAlPQ;EAGI,yBAAA;AAkPZ;AAhPY;;EAEI,cANI;AAwPpB;AA/OY;EACI,yBAVI;AA2PpB","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n.root {\n    @include theme.reset-button();\n    @include theme.typo(body3);\n\n    background-color: theme.color(snow-100);\n    border-radius: theme.get-border-radius(md);\n    gap: theme.spacing(0.5);\n    height: 40px;\n    min-width: 73px;\n    padding: theme.spacing(0, 1.5);\n\n    &,\n    svg {\n        $color: theme.color(space-400);\n\n        color: $color;\n\n        .loadingDots {\n            background-color: $color;\n        }\n    }\n\n    &:disabled {\n        cursor: default;\n\n        * {\n            cursor: default;\n        }\n    }\n\n    &.small {\n        height: 32px;\n    }\n\n    &.fullWidth {\n        width: 100% !important;\n    }\n\n    &.primary {\n        $color: theme.color(snow-50);\n\n        background-color: theme.color(ocean-500);\n\n        &,\n        svg {\n            color: $color;\n        }\n\n        .loadingDots {\n            background-color: $color;\n        }\n    }\n\n    &.secondary {\n        $color: theme.color(ocean-500);\n\n        background-color: theme.color(ocean-200);\n\n        &,\n        svg {\n            color: $color;\n        }\n\n        .loadingDots {\n            background-color: $color;\n        }\n    }\n\n    &.ghost {\n        $color: theme.color(ocean-500);\n\n        background-color: transparent;\n\n        &,\n        svg {\n            color: $color;\n        }\n\n        .loadingDots {\n            background-color: $color;\n        }\n    }\n\n    &.outlined {\n        $color: theme.color(gray-400);\n\n        background-color: theme.color(gray-50);\n        border: 2px solid theme.color(gray-300);\n\n        &,\n        svg {\n            color: $color;\n        }\n\n        .loadingDots {\n            background-color: $color;\n        }\n    }\n\n    &.error {\n        $color: theme.color(snow-50);\n\n        background-color: theme.color(red-500);\n\n        &,\n        svg {\n            color: $color;\n        }\n\n        .loadingDots {\n            background-color: $color;\n        }\n    }\n\n    &.warning {\n        $color: theme.color(space-500);\n\n        background-color: theme.color(yellow-400);\n\n        &,\n        svg {\n            color: $color;\n        }\n\n        .loadingDots {\n            background-color: $color;\n        }\n    }\n\n    &.errorLight {\n        $color: theme.color(red-500);\n\n        background-color: theme.color(red-100);\n\n        &,\n        svg {\n            color: $color;\n        }\n\n        .loadingDots {\n            background-color: $color;\n        }\n    }\n\n    &.warningLight {\n        $color: theme.color(space-500);\n\n        background-color: theme.color(yellow-50);\n\n        &,\n        svg {\n            color: $color;\n        }\n\n        .loadingDots {\n            background-color: $color;\n        }\n    }\n\n    &.disabled svg {\n        color: theme.color(space-200);\n    }\n\n    &:hover,\n    &.loading {\n        background-color: theme.color(snow-200);\n\n        &.primary {\n            background-color: theme.color(ocean-400);\n        }\n\n        &.secondary {\n            $color: theme.color(ocean-400);\n\n            background-color: theme.color(ocean-100);\n\n            &,\n            svg {\n                color: $color;\n            }\n\n            .loadingDots {\n                background-color: $color;\n            }\n        }\n\n        &.ghost {\n            background-color: theme.color(snow-200);\n        }\n\n        &.outlined {\n            $color: theme.color(gray-400);\n\n            background-color: theme.color(gray-100);\n            border: 2px solid theme.color(gray-300);\n\n            &,\n            svg {\n                color: $color;\n            }\n\n            .loadingDots {\n                background-color: $color;\n            }\n        }\n\n        &.error {\n            background-color: theme.color(red-300);\n        }\n\n        &.warning {\n            background-color: theme.color(yellow-200);\n        }\n\n        &.errorLight {\n            background-color: theme.color(red-200);\n        }\n\n        &.warningLight {\n            background-color: theme.color(yellow-100);\n        }\n    }\n\n    &:active {\n        background-color: theme.color(gray-100);\n\n        &.primary {\n            background-color: theme.color(ocean-500);\n        }\n\n        &.secondary {\n            $color: theme.color(ocean-500);\n\n            background-color: theme.color(ocean-200);\n\n            &,\n            svg {\n                color: $color;\n            }\n\n            .loadingDots {\n                background-color: $color;\n            }\n        }\n\n        &.ghost {\n            background-color: theme.color(snow-200);\n        }\n\n        &.error {\n            background-color: theme.color(red-500);\n        }\n\n        &.warning {\n            background-color: theme.color(yellow-400);\n        }\n\n        &.errorLight {\n            background-color: theme.color(red-100);\n        }\n\n        &.warningLight {\n            background-color: theme.color(yellow-50);\n        }\n    }\n\n    &.disabled {\n        background-color: theme.color(snow-100);\n        color: theme.color(space-200);\n        cursor: unset;\n\n        &.primary {\n            $color: theme.color(gray-300);\n\n            background-color: theme.color(gray-50);\n\n            &,\n            svg {\n                color: $color;\n            }\n\n            .loadingDots {\n                background-color: $color;\n            }\n        }\n\n        &.secondary {\n            $color: theme.color(ocean-300);\n\n            background-color: theme.color(ocean-50);\n\n            &,\n            svg {\n                color: $color;\n            }\n\n            .loadingDots {\n                background-color: $color;\n            }\n        }\n\n        &.ghost {\n            $color: theme.color(ocean-300);\n\n            background-color: transparent;\n\n            &,\n            svg {\n                color: $color;\n            }\n\n            .loadingDots {\n                background-color: $color;\n            }\n        }\n\n        &.error {\n            $color: theme.color(snow-50);\n\n            background-color: theme.color(red-100);\n\n            &,\n            svg {\n                color: $color;\n            }\n\n            .loadingDots {\n                background-color: $color;\n            }\n        }\n\n        &.warning {\n            $color: theme.color(space-200);\n\n            background-color: theme.color(yellow-100);\n\n            &,\n            svg {\n                color: $color;\n            }\n\n            .loadingDots {\n                background-color: $color;\n            }\n        }\n\n        &.errorLight {\n            $color: theme.color(red-200);\n\n            background-color: theme.color(red-100);\n\n            &,\n            svg {\n                color: $color;\n            }\n\n            .loadingDots {\n                background-color: $color;\n            }\n        }\n\n        &.warningLight {\n            $color: theme.color(space-200);\n\n            background-color: theme.color(yellow-50);\n\n            &,\n            svg {\n                color: $color;\n            }\n\n            .loadingDots {\n                background-color: $color;\n            }\n        }\n    }\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:math';\n@use 'sass:meta';\n@use './colors';\n\n@function if-important($important) {\n    @return #{if($important, '!important', '')};\n}\n\n@function strip-unit($value) {\n    @if meta.type-of($value) == 'number' and not math.is-unitless($value) {\n        @return math.div($value, ($value * 0 + 1));\n    }\n\n    @return $value;\n}\n\n@function is-map($variable) {\n    @return meta.type-of($variable) == 'map';\n}\n\n@function is-string($variable) {\n    @return meta.type-of($variable) == 'string';\n}\n\n// Reset the button to behave like div\n@mixin reset-button() {\n    appearance: none;\n    background-color: transparent;\n    border: 0;\n    border-radius: 0;\n    color: inherit;\n    cursor: pointer;\n    margin: 0;\n    outline: 0;\n    padding: 0;\n    position: relative;\n    -webkit-tap-highlight-color: transparent;\n    text-align: left;\n    text-decoration: none;\n    user-select: none;\n    vertical-align: middle;\n\n    &::-moz-focus-inner {\n        border-style: none;\n    }\n}\n\n@mixin scrollbar() {\n    // The new standard syntax (Currently only supported in Firefox)\n    scrollbar-color: colors.color(gray-200) colors.color(snow-50);\n    scrollbar-width: thin;\n\n    // For Chrome, Edge, Safari, and Opera\n    ::-webkit-scrollbar {\n        height: 7px;\n        width: 5px;\n    }\n\n    ::-webkit-scrollbar-thumb {\n        background: colors.color(gray-200);\n        border-radius: 5px;\n    }\n\n    ::-webkit-scrollbar-track {\n        background: transparent;\n    }\n\n    ::-webkit-scrollbar-thumb:hover {\n        background: colors.color(gray-200);\n    }\n}\n","@use 'sass:map';\n@use 'sass:math';\n@use 'misc' as *;\n\n$typography-html-font-size: 14px;\n$typography-font-size: 14px;\n$typography-font-family: 'Inter',\n    system-ui,\n    -apple-system,\n    'Segoe UI',\n    'Roboto',\n    'Noto Sans',\n    'Ubuntu',\n    'Cantarell',\n    'Helvetica Neue';\n\n$typography-font-weights: (\n    regular: 400,\n    medium: 500,\n    bold: 700\n);\n\n$typography-variants: (\n    h1: 24px medium 34px -0.47px,\n    h2: 20px medium 30px -0.33px,\n    h3: 20px regular 30px -0.33px,\n    h4: 16px bold 24px -0.18px,\n    h5: 16px medium 24px -0.18px,\n    body1: 14px bold 20px -0.09px,\n    body2: 14px medium 20px -0.09px,\n    body3: 14px regular 20px -0.09px,\n    info1: 12px bold 18px 0.01px,\n    info2: 12px medium 18px 0.01px,\n    info3: 12px regular 18px 0.01px,\n);\n\n@function font-weight($weight: regular) {\n    @return map.get($typography-font-weights, $weight);\n}\n\n@function px2rem($value) {\n    @return math.div($value, $typography-html-font-size) * math.div($typography-font-size, 14px) * 1rem;\n}\n\n@mixin typo-by-values($font-size, $font-weight, $line-height, $letter-spacing) {\n    @include font-weight($font-weight);\n\n    font-size: px2rem($font-size);\n    letter-spacing: $letter-spacing;\n    line-height: $line-height;\n}\n\n@mixin font-weight($weight: regular, $important: false) {\n    font-weight: font-weight($weight) if-important($important);\n}\n\n@mixin typo($variant) {\n    $variant-values: map.get($typography-variants, $variant);\n\n    @include typo-by-values($variant-values...);\n\n    // TODO: remove this (if it was redundant) after the new typography replaced the old one\n    font-family: $typography-font-family;\n}\n\n@mixin truncate() {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__O+MIY`,
	"ocean-50": `styles_ocean-50__LmsZO`,
	"ocean-100": `styles_ocean-100__GD6w6`,
	"ocean-200": `styles_ocean-200__EKxLB`,
	"ocean-300": `styles_ocean-300__FBN5n`,
	"ocean-400": `styles_ocean-400__NApyN`,
	"ocean-500": `styles_ocean-500__J9-35`,
	"ocean-600": `styles_ocean-600__dUOif`,
	"space-50": `styles_space-50__rp5V+`,
	"space-100": `styles_space-100__3wyT2`,
	"space-200": `styles_space-200__7+APP`,
	"space-300": `styles_space-300__Y304i`,
	"space-400": `styles_space-400__cOSnH`,
	"space-500": `styles_space-500__4qwK1`,
	"gray-50": `styles_gray-50__ttu+N`,
	"gray-100": `styles_gray-100__4eTyx`,
	"gray-200": `styles_gray-200__lwQPW`,
	"gray-300": `styles_gray-300__GkG+T`,
	"gray-400": `styles_gray-400__ZAlnN`,
	"gray-500": `styles_gray-500__STjTT`,
	"green-50": `styles_green-50__EEINr`,
	"green-100": `styles_green-100__18+90`,
	"green-200": `styles_green-200__iFeXM`,
	"green-300": `styles_green-300__-wYbW`,
	"green-400": `styles_green-400__G1aj8`,
	"green-500": `styles_green-500__5A0gl`,
	"red-50": `styles_red-50__2abRC`,
	"red-100": `styles_red-100__rKeZ6`,
	"red-200": `styles_red-200__MQ9i8`,
	"red-300": `styles_red-300__4ePCq`,
	"red-400": `styles_red-400__hI+yO`,
	"red-500": `styles_red-500__A0yUe`,
	"yellow-50": `styles_yellow-50__gzrmK`,
	"yellow-100": `styles_yellow-100__SMRhH`,
	"yellow-200": `styles_yellow-200__MmipN`,
	"yellow-300": `styles_yellow-300__ilxM+`,
	"yellow-400": `styles_yellow-400__lrwou`,
	"yellow-500": `styles_yellow-500__5rqXt`,
	"orange-50": `styles_orange-50__ktf3r`,
	"orange-100": `styles_orange-100__wl11w`,
	"orange-200": `styles_orange-200__YSQRp`,
	"orange-300": `styles_orange-300__nJOKm`,
	"orange-400": `styles_orange-400__UV04h`,
	"orange-500": `styles_orange-500__CYtzS`,
	"turquoise-50": `styles_turquoise-50__LoHj3`,
	"turquoise-100": `styles_turquoise-100__O6CoD`,
	"turquoise-200": `styles_turquoise-200__pw3f0`,
	"turquoise-300": `styles_turquoise-300__FNGmV`,
	"turquoise-400": `styles_turquoise-400__m8FNQ`,
	"turquoise-500": `styles_turquoise-500__zgKcL`,
	"turquoise-600": `styles_turquoise-600__fDktm`,
	"violet-50": `styles_violet-50__5x2Ef`,
	"violet-100": `styles_violet-100__TugCe`,
	"violet-200": `styles_violet-200__O6wVi`,
	"violet-300": `styles_violet-300__A80v2`,
	"violet-400": `styles_violet-400__QO94e`,
	"violet-500": `styles_violet-500__EXSag`,
	"snow-50": `styles_snow-50__l2ukB`,
	"snow-100": `styles_snow-100__voKiz`,
	"snow-200": `styles_snow-200__fbstb`,
	"snow-300": `styles_snow-300__PbWYi`,
	"snow-400": `styles_snow-400__Fo2Dx`,
	"snow-500": `styles_snow-500__Z1q16`,
	"background-color": `styles_background-color__VKeQU`,
	"ocean": `styles_ocean__gvTiZ`,
	"ocean-light": `styles_ocean-light__D2tWW`,
	"green": `styles_green__KhGxb`,
	"green-light": `styles_green-light__riBJm`,
	"red": `styles_red__7Y58A`,
	"red-light": `styles_red-light__P-3lN`,
	"orange": `styles_orange__5Fp1c`,
	"orange-light": `styles_orange-light__RzwdQ`,
	"space": `styles_space__ioGlY`,
	"space-light": `styles_space-light__dqG+0`,
	"gray-light": `styles_gray-light__wG8is`,
	"violet": `styles_violet__l8vzG`,
	"violet-light": `styles_violet-light__6awvW`,
	"yellow": `styles_yellow__-UN8p`,
	"yellow-light": `styles_yellow-light__Bfvkm`,
	"root": `styles_root__wuWWb`,
	"loadingDots": `styles_loadingDots__cEVZc`,
	"small": `styles_small__un6+5`,
	"fullWidth": `styles_fullWidth__PzUwe`,
	"primary": `styles_primary__LoXCN`,
	"secondary": `styles_secondary__dvfx8`,
	"ghost": `styles_ghost__fHgtd`,
	"outlined": `styles_outlined__can7d`,
	"error": `styles_error__bFEK+`,
	"warning": `styles_warning__fIt24`,
	"errorLight": `styles_errorLight__V1VTM`,
	"warningLight": `styles_warningLight__6qI+e`,
	"disabled": `styles_disabled__9PiL9`,
	"loading": `styles_loading__2jfYr`
};
export default ___CSS_LOADER_EXPORT___;
